// ============================================================
//  CONFIGURACIÓN CENTRAL — FM REAL 96.3
//  Modificá SOLO este archivo para actualizar datos, enlaces,
//  redes sociales, teléfono, WhatsApp, programación, etc.
//  Los componentes leen todo desde acá.
// ============================================================

export const radioConfig = {
  name: "FM REAL 96.3",
  frequency: "96.3 MHz",
  city: "Las Breñas",
  timeZone: "America/Argentina/Buenos_Aires",
  province: "Chaco",
  country: "Argentina",

  // URL oficial del portal de streaming (abre en nueva pestaña).
  // Si en el futuro se obtiene la URL DIRECTA del stream de audio,
  // colocarla en `directStreamUrl` y el reproductor la usará con <audio>.
  streamUrl: "https://streaminglocucionar.com/portal/?p=10740",
  directStreamUrl: "https://streaming2.locucionar.com/proxy/fmreal963?mp=/stream", // stream directo -> reproduce en la misma página

  lasBrenasDigitalUrl: "https://lasbrenasdigital.com.ar/",

  // Activar/desactivar la barra flotante inferior en mobile.
  showMobileBottomBar: true,

  assets: {
    logo: "/assets/fmreal-logo.png",
    lasBrenasDigitalLogo: "/assets/lasbrenas-digital.png",
    studioPhoto: "/assets/studio.png",
  },

  // ---- CONTACTO ----
  // Dejar en "" los datos que todavía no fueron provistos.
  // Los ítems vacíos se muestran como "Pendiente de cargar".
  // ---- CONTACTO ----
  contact: {
    whatsapp: "5493731654051", // 3731-654051
    phone: "+54 9 3731 654051",
    email: "fabiorodriguez2012@hotmail.com.ar",
    address: "Las Breñas, Chaco",
  },

  social: {
    facebook: "https://www.facebook.com/FmReal96.3",
  },

  // ---- PROGRAMACIÓN ----
  schedule: [
    {
      name: "La vida real",
      schedule: "08:40 a 12:00 hs",
      days: "Lunes a Viernes",
      hosts: "Fabio Rodríguez",
      image: "/assets/la-vida-real-fabio-rodriguez.jpg",
      whatsapp: "5493731438356",
      seoDescription: "Disfrutá de 'La vida real' con la conducción de Fabio Rodríguez, de lunes a viernes de 08:40 a 12:00 hs por FM REAL 96.3 de Las Breñas, Chaco. Comunicate al WhatsApp 3731-438356 para dejar tus saludos y mensajes en vivo.",
    },
    {
      name: "Siesta chamamecera",
      schedule: "12:00 a 14:00 hs",
      days: "Lunes a Viernes",
      hosts: "Ricardo Lotto",
      image: "/assets/siesta-chamamecera-ricardo-lotto.webp",
      seoDescription: "Viví el auténtico sentimiento de nuestra música litoraleña con 'Siesta chamamecera' conducido por Ricardo Lotto. De 12:00 a 14:00 hs, acompañá tu siesta en Las Breñas y el Sudoeste Chaqueño con los mejores chamamés y la alegría de nuestra gente en FM REAL 96.3.",
    },
    {
      name: "Revista de noticias",
      schedule: "16:00 a 18:00 hs",
      days: "Lunes a Viernes",
      hosts: "Juan Carlos Aguiar y Nelson Figueroa",
      image: "/assets/revista-noticias-aguiar-figueroa.webp",
      seoDescription: "Mantenete informado con todo el análisis periodístico, notas de interés general y la actualidad de Las Breñas en 'Revista de noticias' con Juan Carlos Aguiar y Nelson Figueroa. De 16:00 a 18:00 hs por FM REAL 96.3.",
    },
    {
      name: "Al toke",
      schedule: "19:00 a 21:00 hs",
      days: "Lunes a Viernes",
      hosts: "Gustavo Belizán",
      image: "/assets/al-toke-gustavo-belizan.jpg",
      seoDescription: "SUENA TÚ MÚSICA 'aL Toke'. En una nueva tarde mágica junto a vos con la conducción de Gustavo Belizán. De 19:00 a 21:00 hs: música, información, entrevistas y mucho más en FM REAL 96.3. ¿Cómo viene tu Tarde? ¡Contanos!. Dejanos tu mensaje por SMS o WhatsApp al 3731-654051.",
    },
    {
      name: "Voces, hechos y protagonistas",
      schedule: "09:00 a 12:00 hs",
      days: "Sábados",
      hosts: "Laura Jasinski",
      image: "/assets/voces-laura-jasinski.webp",
      seoDescription: "Disfrutá de 'Voces, hechos y protagonistas' con la conducción y producción de Laura Jasinski. Todos los sábados de 09:00 a 12:00 hs por FM REAL 96.3 de Las Breñas, Chaco. Entrevistas exclusivas, análisis y los temas que marcan la agenda semanal.",
    },
  ],

  // ---- NOTICIAS / FEED LAS BREÑAS DIGITAL ----
  lasBrenasNews: [
    {
      title: "Portada Oficial — Las Breñas Digital",
      snippet: "Portal de noticias y actualidad de Las Breñas, Chaco y la región. Toda la información al instante.",
      image: "/assets/lasbrenas-digital.png",
      url: "https://lasbrenasdigital.com.ar/",
    },
    {
      title: "Actualidad Comunitaria e Institucional",
      snippet: "Novedades sobre obras, educación, cultura y eventos destacados en nuestra ciudad de Las Breñas.",
      image: "/assets/studio.png",
      url: "https://lasbrenasdigital.com.ar/",
    },
    {
      title: "Deportes, Sociedad y Cultura Regional",
      snippet: "Cobertura especial del deporte local, entrevistas a personalidades y acontecimientos del sudoeste chaqueño.",
      image: "/assets/fmreal-logo.png",
      url: "https://lasbrenasdigital.com.ar/",
    },
  ],
};

export default radioConfig;
